import React from 'react'
import TabsThree from '../requests/shared/helpers/TabsThree'
import LaborDriversSalesTable from './LaborDriversSalesTable'
import LaborDriversAttributesTable from './LaborDriversAttributesTable'
import LaborDriversFlagsTable from './LaborDriversFlagsTable'

function LaborDriversDisplay(props) {

  const [activeTab, setActiveTab] = React.useState('Sales')

  function handleTabButtonPress(target) {
    setActiveTab(target)
  }

  return (
    <div>
      <div className="w-[420px] max-w-full px-6 mt-6 sm:w-full">
        <TabsThree
          activeTab={activeTab}
          handleTabButtonPress={handleTabButtonPress}
          tab1="Sales"
          tab2="Attributes"
          tab3="Flags"
        />
      </div>
      <div className="w-full">
        {
          activeTab === 'Sales' ?
            <div>
              <LaborDriversSalesTable
                companyId={props.companyId}
                post_labor_driver_sales={props.post_labor_driver_sales}
                laborDrivers={props.laborDrivers}
                selectedCompany={props.selectedCompany}
                backfill_labor_driver_sales={props.backfill_labor_driver_sales}
                post_labor_driver_routed_sales={props.post_labor_driver_routed_sales}
                backfill_labor_driver_routed_sales={
                  props.backfill_labor_driver_routed_sales
                }
                delete_labor_driver={props.delete_labor_driver}
                storesInfo={props.storesInfo}
                scenarioMode={props.scenarioMode}
                readOnly={props.readOnly}
              />
            </div> :
          activeTab === 'Attributes' ?
            <div>
              <LaborDriversAttributesTable
                post_labor_driver_company_attribute={props.post_labor_driver_company_attribute}
                laborDrivers={props.laborDrivers}
                delete_labor_driver={props.delete_labor_driver}
                laborDriverStoreAttributes={props.laborDriverStoreAttributes}
                post_labor_driver_store_attribute={
                  props.post_labor_driver_store_attribute
                }
                readOnly={props.readOnly}
                embedded
              />
            </div> :
          activeTab === 'Flags' ?
            <div>
              <LaborDriversFlagsTable
                post_labor_driver_company_attribute={props.post_labor_driver_company_attribute}
                laborDrivers={props.laborDrivers}
                laborProgramFlags={props.laborProgramFlags}
                post_labor_program_flag_company={props.post_labor_program_flag_company}
                delete_labor_program_flag_company={props.delete_labor_program_flag_company}
                delete_labor_driver={props.delete_labor_driver}
                laborProgramFlagsStoreOverrides={
                  props.laborProgramFlagsStoreOverrides
                }
                post_labor_program_flag_store={
                  props.post_labor_program_flag_store
                }
                readOnly={props.readOnly}
                embedded
              />
            </div> :
          <div></div>
        }
      </div>
    </div>
  )
}

export default LaborDriversDisplay
